import { Section } from "../ui/Section";
import { Eyebrow } from "../ui/Eyebrow";
import { H2, Highlight } from "../ui/Heading";
import { STEPS } from "../data/steps";
import { StepRow } from "./StepRow";

export function HowItWorks() {
  return (
    <Section id="how">
      <Eyebrow n="06">How it works</Eyebrow>
      <H2>
        Three steps. Then it just <Highlight>runs</Highlight>.
      </H2>
      <div className="mt-16 flex flex-col gap-8">
        {STEPS.map((step) => (
          <StepRow key={step.n} step={step} />
        ))}
      </div>
    </Section>
  );
}
